<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { Radar } from 'lucide-svelte';

  import { neighborSamples } from '$lib/stores/neighbors';
  import { maxSamples } from '$lib/stores/neighbors';

  /**
   * Similarity mode with no examples chosen yet.
   *
   * # What was here
   *
   * An 80px accent circle, a `text-2xl font-bold` heading, a bordered panel
   * holding three numbered accent discs explaining how the mode works, and an
   * accent-on-accent band repeating how many examples were selected — on a
   * screen whose only job is "pick a company in the panel beside this".
   *
   * The three-step explanation is gone rather than restyled. The guided flow's
   * similarity door asks for the examples directly, with the search box on the
   * screen, so a customer who needs telling how this works is better served by
   * being walked through it than by reading about it. What is left is the same
   * quiet shape the other empty states use, and the one fact this screen knows
   * that the panel does not repeat: how many examples are in so far.
   */

  const chosen = $derived($neighborSamples.length);
</script>

<div class="max-w-md text-center">
  <div
    class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-surface bg-surface-sunken"
  >
    <Radar class="h-6 w-6 text-gray-400" />
  </div>

  <h2 class="mb-1.5 text-base font-semibold text-gray-900">
    {$_('headings.findSimilarCompanies')}
  </h2>
  <p class="mb-4 text-sm text-gray-600">{$_('instructions.searchBySimilarity')}</p>

  <p class="text-xs text-gray-500">
    {#if chosen === 0}
      {$_('instructions.startBySearching')}
    {:else}
      {$_('guided.samples.hint', { values: { max: maxSamples } })}
    {/if}
  </p>
</div>
